import { routes } from '@/core/routing/routes/routes.gb';
import { createURL } from '@/core/routing/URLParser';
import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';
import { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { type Brand } from '@/domains/productDiscovery/ProductPage/modules/Brand/brand.model';
import {
  GRAPHQL_SUCCESS,
  GraphqlSuccess,
} from '@/productDiscovery/ProductPage/detail.actions';

export const GET_BRAND_SUCCESS = 'GET_BRAND_SUCCESS';

export interface BrandState {
  id: number | null;
  name: string | null;
  imageUrl: string | null;
  url: string | null;
  description: string | null;
}

export interface GetBrandSuccess {
  type: typeof GET_BRAND_SUCCESS;
  brand: Brand;
}

export const getBrandSuccess = (brand: Brand): GetBrandSuccess => ({
  type: GET_BRAND_SUCCESS,
  brand,
});

export const initialBrandState: BrandState = {
  id: null,
  name: null,
  imageUrl: null,
  url: null,
  description: null,
};

export const brandSelector = (state: SpartacuxProductDiscoveryDomainState) =>
  state.productDiscovery?.productPage?.brand || initialBrandState;

export default function reducer(
  state = initialBrandState,
  action:
    | GraphqlSuccess
    | GetBrandSuccess
    | HydrateAction<SpartacuxProductDiscoveryDomainState>,
): BrandState {
  switch (action.type) {
    case HYDRATE:
      return brandSelector(action.state);

    case GET_BRAND_SUCCESS:
      return {
        ...state,
        ...action.brand,
      };

    case GRAPHQL_SUCCESS: {
      const brandData = action.payload?.getChannelBrandByPublicIdAndPlatform;
      if (!brandData) return initialBrandState;

      return {
        ...state,
        description: brandData.description || null,
        id: brandData.publicId,
        imageUrl: brandData.logo || null,
        name: brandData.title,
        url: createURL(routes.brand, {
          brand: brandData.slug || '',
          id: brandData.publicId.toString(),
        }),
      };
    }

    default:
      return state;
  }
}
